import DatePicker from '../../../components/Forms/DatePicker/DatePicker';
import InputField from '../../../components/Forms/Input/InputField';
import { useBasePurchase } from '../../../hooks/purchases/useBasePurchase';

const PurchaseCreditYearsSection = () => {
  const { form, updateField, purchaseSettlementLoaded } = useBasePurchase();

  return (
    <>
      <DatePicker
        name="paymentCondition.creditDueDate"
        label="Fecha Plazo del Crédito"
        iconKey="calendar"
        value={form.paymentCondition?.creditDueDate || ''}
        placeholder="Fecha automática"
        helperText="Este campo se calcula automáticamente según los años."
        disabled
        onChange={() => {}}
      />

      <InputField
        name="paymentCondition.creditYears"
        label="Años Plazo del Crédito"
        iconKey="calendar"
        type="number"
        min={0}
        placeholder="Años plazo del crédito"
        value={
          form.paymentCondition?.creditYears !== undefined &&
          form.paymentCondition?.creditYears !== null
            ? form.paymentCondition.creditYears
            : ''
        }
        onChange={(e) => {
          const value = e.target.value.trim();

          if (value === '') {
            updateField('paymentCondition', {
              ...form.paymentCondition,
              creditYears: undefined,
              creditDueDate: '',
            });
            return;
          }

          const years = Number(value);
          if (form.purchaseDate && !isNaN(years)) {
            const start = new Date(form.purchaseDate);
            const dueDate = new Date(start);
            dueDate.setFullYear(start.getFullYear() + years);

            updateField('paymentCondition', {
              ...form.paymentCondition,
              creditYears: years,
              creditDueDate: dueDate.toISOString().split('T')[0],
            });
          }
        }}
        disabled={purchaseSettlementLoaded}
      />
    </>
  );
};

export default PurchaseCreditYearsSection;
